import Repository from "./Repository";

const WITHDRAW = "/withdraw";
export default {
  setWithdraw(payload) {
    console.log(payload);
    return Repository.post(`${WITHDRAW}`, payload);
  },
};
